import { useEffect, useState } from 'react';

interface UseOverflowDetectionProps {
  contentRef: React.RefObject<HTMLDivElement>;
  currentText: string;
}

export const useOverflowDetection = ({
  contentRef,
  currentText,
}: UseOverflowDetectionProps) => {
  const [hasOverflow, setHasOverflow] = useState(false);
  const [expandedHeight, setExpandedHeight] = useState("1.5em");
  const [collapsedHeight, setCollapsedHeight] = useState("1.5em");

  useEffect(() => {
    if (!contentRef.current) return;

    const checkOverflow = () => {
      const element = contentRef.current;
      if (!element) return;

      const textElement = element.querySelector('div');
      if (!textElement) return;

      const originalClass = textElement.className;
      textElement.className = originalClass.replace('line-clamp-1', '');
      const hasOverflowContent = element.scrollHeight > element.clientHeight;
      setExpandedHeight(`${element.scrollHeight}px`);

      textElement.className = originalClass;
      setCollapsedHeight(`${textElement.offsetHeight}px`);

      setHasOverflow(hasOverflowContent);
    };


    checkOverflow();

    window.addEventListener('resize', checkOverflow);

    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [contentRef, currentText]);

  return {
    hasOverflow,
    expandedHeight,
    collapsedHeight,
  };
}; 